export const createPaymentMethod = `
    mutation createPaymentMethod($input: CreatePaymentMethodInput!) {
        createPaymentMethod(input:$input) {
              id
              billingDetails {
                address
                email
                name
                phone
              }
              card {
                brand
                country
                expMonth
                expYear
                funding
                last4
              }
              created
              customerId
              type
        }
}`;

export const updatePaymentMethod = `
    mutation updatePaymentMethod($input: UpdatePaymentMethodInput!) {
        updatePaymentMethod(input:$input){
              id
              billingDetails {
                address
                email
                name
                phone
              }
              card {
                brand
                country
                expMonth
                expYear
                funding
                last4
              }
              customerId
              type
        }
}`;

export const deletePaymentMethod = `
    mutation deletePaymentMethod($input: DeletePaymentMethodInput!) {
        deletePaymentMethod(input:$input)
}`;
